import cx from "classnames";
import React, { ReactNode } from "react";

import { MetaOg } from "@/components/MetaOg";
import { PaddingWrapper } from "@/components/PaddingWrapper";
import { Footer } from "@/layouts/components/Footer/Footer";
import { Header } from "@/layouts/components/Header/Header";

import styles from "./styles.module.css";

export type HeaderThemes = "light" | "dark";
export type HeaderVersions = "full" | "minimal" | "logo";

export type PageLayoutProps = {
  title: string;
  titleSuffix?: string;
  description?: string;
  pageTheme?: "light" | "dark";
  headerVersion?: HeaderVersions;
  headerTheme?: HeaderThemes;
  headerCta?: string; // used in minimal header
  hideFooter?: boolean;
  className?: string;
  heroClassName?: string | undefined;
  heroContent?: ReactNode;
  onlyXPadding?: boolean;
  children?: ReactNode;
  ogImage?: string;
  seoTitle?: string;
  translations?: { language: string; path: string }[];
  articleTitle?: string;
};

export const PageLayout = ({
  title,
  titleSuffix,
  description,
  pageTheme = "light",
  headerVersion,
  headerTheme,
  headerCta,
  hideFooter,
  className,
  heroClassName,
  heroContent,
  onlyXPadding,
  children,
  ogImage,
  seoTitle,
  translations,
}: PageLayoutProps) => {
  const hasMinimalPadding = headerVersion === "minimal";

  // SEO props
  seoTitle = seoTitle || title;
  const inverse = headerTheme === "dark" ? true : false;

  return (
    <>
      <MetaOg
        title={seoTitle}
        titleSuffix={titleSuffix}
        ogImage={ogImage}
        description={description}
        translations={translations}
      />
      <div className={cx(className, styles.container, styles[pageTheme])}>
        <Header
          type={headerVersion}
          title={title}
          cta={headerCta}
          inverse={inverse}
          overlay
          multicolor
        />
        <main>
          {heroContent && (
            <div className={cx(styles.heroContent, heroClassName)}>
              {heroContent}
            </div>
          )}
          {children && (
            <PaddingWrapper
              clearMenu={!heroContent && !hasMinimalPadding}
              onlyX={onlyXPadding}
              className={styles.paddingWrapper}
            >
              {children}
            </PaddingWrapper>
          )}
        </main>
      </div>
      {!hideFooter && <Footer />}
    </>
  );
};

export default PageLayout;
